import React, { useEffect, useState } from 'react';
import axios from 'axios';
import APIEndPoints from '../../../middleware/APIEndPoints';

const Workinghistory = () => {
  const [workHistory, setWorkHistory] = useState([]);
  const [newWork, setNewWork] = useState({ title: '', company: '', duration: '', description: '' });
  const [editWork, setEditWork] = useState(null);
  const baseUrl = APIEndPoints.workinghistory.url;

  // Fetch all work history records
  const fetchWorkHistory = async () => {
    try {
      const response = await axios.get(baseUrl);
      setWorkHistory(response.data);
    } catch (error) {
      console.error('Error fetching work history:', error);
    }
  };

  // Add new work history record
  const addWorkHistory = async () => {
    try {
      const response = await axios.post(baseUrl, newWork);
      setWorkHistory([...workHistory, response.data]);
      setNewWork({ title: '', company: '', duration: '', description: '' });
    } catch (error) {
      console.error('Error adding work history:', error);
    }
  };

  // Update existing work history record
  const updateWorkHistory = async () => {
    try {
      const response = await axios.put(`${baseUrl}/${editWork._id}`, editWork);
      setWorkHistory(workHistory.map(work => (work._id === editWork._id ? response.data : work)));
      setEditWork(null);
    } catch (error) {
      console.error('Error updating work history:', error);
    }
  };

  // Delete work history record
  const deleteWorkHistory = async (id) => {
    try {
      await axios.delete(`${baseUrl}/${id}`);
      setWorkHistory(workHistory.filter(work => work._id !== id));
    } catch (error) {
      console.error('Error deleting work history:', error);
    }
  };

  useEffect(() => {
    fetchWorkHistory();
  }, []);

  return (
    <div className="bg-[#1d0c39] min-h-screen p-8 text-white">
      <h1 className="text-3xl font-bold mb-6">Work History</h1>
      
      {/* Add New Work History Form */}
      <div className="mb-8">
        <h2 className="text-xl mb-4">Add New Work History</h2>
        <input
          type="text"
          placeholder="Title"
          value={newWork.title}
          onChange={(e) => setNewWork({ ...newWork, title: e.target.value })}
          className="block mb-2 p-2 w-full text-black"
        />
        <input
          type="text"
          placeholder="Company"
          value={newWork.company}
          onChange={(e) => setNewWork({ ...newWork, company: e.target.value })}
          className="block mb-2 p-2 w-full text-black"
        />
        <input
          type="text"
          placeholder="Duration"
          value={newWork.duration}
          onChange={(e) => setNewWork({ ...newWork, duration: e.target.value })}
          className="block mb-2 p-2 w-full text-black"
        />
        <textarea
          placeholder="Description"
          value={newWork.description}
          onChange={(e) => setNewWork({ ...newWork, description: e.target.value })}
          className="block mb-2 p-2 w-full text-black"
        />
        <button onClick={addWorkHistory} className="bg-green-600 px-4 py-2 rounded hover:bg-green-700">
          Add Work History
        </button>
      </div>

      {/* Edit Work History Form */}
      {editWork && (
        <div className="mb-8">
          <h2 className="text-xl mb-4">Edit Work History</h2>
          <input
            type="text"
            placeholder="Title"
            value={editWork.title}
            onChange={(e) => setEditWork({ ...editWork, title: e.target.value })}
            className="block mb-2 p-2 w-full text-black"
          />
          <input
            type="text"
            placeholder="Company"
            value={editWork.company}
            onChange={(e) => setEditWork({ ...editWork, company: e.target.value })}
            className="block mb-2 p-2 w-full text-black"
          />
          <input
            type="text"
            placeholder="Duration"
            value={editWork.duration}
            onChange={(e) => setEditWork({ ...editWork, duration: e.target.value })}
            className="block mb-2 p-2 w-full text-black"
          />
          <textarea
            placeholder="Description"
            value={editWork.description}
            onChange={(e) => setEditWork({ ...editWork, description: e.target.value })}
            className="block mb-2 p-2 w-full text-black"
          />
          <button onClick={updateWorkHistory} className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-700 mr-2">
            Update Work History
          </button>
          <button onClick={() => setEditWork(null)} className="bg-gray-600 px-4 py-2 rounded hover:bg-gray-700">
            Cancel
          </button>
        </div>
      )}

      {/* List of Work History */}
      <div>
        <h2 className="text-xl mb-4">Existing Work History</h2>
        {workHistory.length === 0 ? (
          <p>No work history available.</p>
        ) : (
          workHistory.map((work) => (
            <div key={work._id} className="border-b border-gray-500 pb-4 mb-4">
              <h3 className="text-lg font-semibold">{work.title}</h3>
              <p>Company: {work.company}</p>
              <p>Duration: {work.duration}</p>
              <p>Description: {work.description}</p>
              <button
                onClick={() => setEditWork(work)}
                className="bg-yellow-600 px-4 py-2 rounded hover:bg-yellow-700 mr-2 mt-2"
              >
                Edit
              </button>
              <button
                onClick={() => deleteWorkHistory(work._id)}
                className="bg-red-600 px-4 py-2 rounded hover:bg-red-700 mt-2"
              >
                Delete
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Workinghistory;
